import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Title, SelectPrintType, Input, SelectDock, Card, SelectResource } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { translate, convertToUppercase, getPreAllocationArea, configs } from '../../../utils/util';
import ReceiptContainerModal from './ReceiptContainerModal'
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import Select from '../../../components/UI/Select';
import ContainerService from '../../../services/ContainerService';

const ReceiptContainer = (props) => {
    const [model, setModel] = useState({
        container: null,
        mdrBai: configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items).mdrBaiCode || '',
        preAllocationArea: getPreAllocationArea(getVision()),
        print: props.printSelect,
        place: "1"
    });
    let receiptContainerModal;

    useEffect(() => {
        if ((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && !props.printSelect) {
            props.setPrintSelect(ENUMS.ePrintTypes.Click.value)
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.items.length > 0) {
            receiptContainerModal.show();
        }
        // eslint-disable-next-line
    }, [props.items])

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onConfirmModal = () => {
        var data = {
            name: model.container,
            container: model.container,
            preAllocationArea: model.preAllocationArea,
            dock: props.user.dock,
            shed: props.sheds.find((i) => i.id === props.user.shed)?.code,
            printer: props.user.printer,
            print: model.print
        }

        if (props.containerYard) {
            props.sendSpanning(data, () => {
                receiptContainerModal.close();
                props.onCancel();
            });
        } else {
            props.receiptByContainer(data, () => {
                receiptContainerModal.close();
                props.onCancel();
            });
        }

    }

    const onSearch = () => {
        if (validateInputsRequired("formContainerInput")) {
            props.onSubmit(model.container)
        }
    }

    return (
        <div>
            <Title label={"Recebimento por Container"} />
            <div className="container-fluid">
                <div className="container" style={{ width: '96%' }}>
                    <Card>
                        <div id="formContainerInput" className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding col s12">
                                <Input
                                    id="container"
                                    name="container"
                                    label={translate('container', 'physical-confirmation')}
                                    type="text"
                                    value={model.container || ''}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div className={`${model.place === "1" ? '' : 'input-field'} col s6 no-padding`}>
                                <Select
                                    id="place"
                                    name="place"
                                    label={translate('area', 'physical-confirmation')}
                                    notOption
                                    display="description"
                                    defaultValue={model.place}
                                    change={onChange}
                                    data={[
                                        { id: "1", text: translate('storage', 'physical-confirmation') },
                                        { id: "2", text: translate('entrance-area', 'physical-confirmation') },
                                    ]}
                                />
                            </div>
                            {
                                model.place === "1" &&
                                <div className="input-field  col s5" style={{ paddingTop: '20px' }}>
                                    <Input
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        required
                                        type="text"
                                        defaultValue={model.preAllocationArea}
                                        onChange={onChange}
                                        label={translate('pre-allocation-area', 'physical-confirmation')}
                                        onKeyUp={convertToUppercase}
                                    />
                                </div>
                            }
                            {
                                model.place === "2" &&
                                <div className="input-field no-padding col s5">
                                    <SelectDock
                                        unload
                                        required={model.place === 2}
                                        id="preAllocationArea"
                                        name="preAllocationArea"
                                        filterArea
                                        shedId={props.user.shed}
                                        value={props.user.dock}
                                        onChange={onChange}
                                    />
                                </div>
                            }
                            <div className="input-field no-padding col s6">
                                <SelectPrintType
                                    required
                                    onChange={onChange}
                                    value={model?.print || ""}
                                />
                            </div>
                            <div className="input-field no-padding col s5">
                                <SelectResource
                                    name="resourceId"
                                    id="resourceId"
                                    required={model.print === ENUMS.ePrintTypes.Logistics.value || model.print === ENUMS.ePrintTypes.Click.value}
                                    value={model?.resourceId}
                                    onChange={onChange} />
                            </div>
                        </div>
                    </Card>
                    <div className="row">
                        <div className="col s12 lefth">
                            <Button full="true" className="col s6 btn-principal" text={translate('delivery:general.search')} onClick={onSearch} />
                        </div>
                    </div>
                </div>
            </div>
            <ReceiptContainerModal
                ref={((el) => receiptContainerModal = el)}
                id="receiptContainerModal"
                items={props.items}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
                onConfirm={onConfirmModal}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        printSelect: state.physicalConfirmationReducer.printSelect
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        receiptByContainer: (dto, callback) => {
            dispatch(PhysicalConfirmationService.receiptByContainer(dto, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        sendSpanning: (filter, callback) => {
            dispatch(ContainerService.sendContainerSpawning(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptContainer));